import { render, staticRenderFns } from "./MyReservations.vue?vue&type=template&id=d991c1c0"
import script from "./MyReservations.vue?vue&type=script&lang=ts"
export * from "./MyReservations.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports